var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGroupItem = function SvgGroupItem(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 200.239,
    viewBox: "0 0 228 200.239",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90486",
    "data-name": "Group 90486",
    transform: "translate(-56.111 -85.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(56.111 272.971)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    cx: 114,
    cy: 6.162,
    rx: 114,
    ry: 6.162,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Box",
    transform: "translate(90.392 224.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    d: "M0,0H75.521a0,0,0,0,1,0,0V36.337a6.47,6.47,0,0,1-6.47,6.47H6.47A6.47,6.47,0,0,1,0,36.337V0A0,0,0,0,1,0,0Z",
    transform: "translate(6.875 10.083)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M121.29,331.624h53.436l-6.575-8.413a5.654,5.654,0,0,0-4-1.671H116.1c-1.486,0-2.107.748-1.386,1.671Z",
    transform: "translate(-114.415 -321.541)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M121.29,331.624h53.436l-6.575-8.413a5.654,5.654,0,0,0-4-1.671H116.1c-1.486,0-2.107.748-1.386,1.671Z",
    transform: "translate(-114.415 -321.541)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M217.106,334.085H163.67l6.575-5.483a7.39,7.39,0,0,1,4-1.089h48.052c1.486,0,2.107.487,1.386,1.089Z",
    transform: "translate(-134.71 -324.002)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    d: "M0,0H53.436a0,0,0,0,1,0,0V36.337a6.47,6.47,0,0,1-6.47,6.47H6.47A6.47,6.47,0,0,1,0,36.337V0A0,0,0,0,1,0,0Z",
    transform: "translate(28.96 10.083)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M137.389,338.69v26.742l1.847-1.458,1.3,1.458,1.131-1.623,1.154,1.623,1.615-1.221,1.773,1.221V338.69Z",
    transform: "translate(-123.881 -328.607)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(99.552 85.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 36.952)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 9.497,
    y1: 7.973,
    transform: "translate(6.808 45.871)",
    fill: "none",
    stroke: "#407bff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.896,
    y1: 2.432,
    transform: "translate(18.329 55.543)",
    fill: "none",
    stroke: "#407bff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M184.546,222.912l31.326-39.155-41.71-35.016-27.656,31.708-4.093,7.932a2.207,2.207,0,0,0,.278,3.226l37.639,31.6A3.115,3.115,0,0,0,184.546,222.912Z",
    transform: "translate(-134.875 -148.249)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M174.773,225.782l-4.509,7.263,1.813.389.616,1.686,1.208.07.556,1.437,1.478.432,1.138,1.8,4.509-7.263Z",
    transform: "translate(-146.587 -179.992)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M217.779,182.611l-28.094,31.34-39.906-33.5,27.656-31.708Z",
    transform: "translate(-138.146 -148.248)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(51.538 34.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M245.744,206.347l-28.095,31.34,11.632.861,27.656-31.708Z",
    transform: "translate(-217.65 -206.347)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M245.744,206.347l-28.095,31.34,11.632.861,27.656-31.708Z",
    transform: "translate(-217.65 -206.347)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M158.089,147.9l-28.094,31.34,11.632.861L169.282,148.4Z",
    transform: "translate(-129.995 -147.904)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M158.089,147.9l-28.094,31.34,11.632.861L169.282,148.4Z",
    transform: "translate(-129.995 -147.904)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M224.886,192.262l8.652-9.651-40.345-33.871-5.168,12.44Z",
    transform: "translate(-153.905 -148.248)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M149.778,180.449l27.656-31.708-5.168,12.44-19.471,21.8Z",
    transform: "translate(-138.146 -148.248)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(52.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M281.354,105.609c.112.38,0,.747-.248.82s-.539-.176-.651-.556,0-.746.247-.819S281.243,105.23,281.354,105.609Z",
    transform: "translate(-244.17 -93.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M281.472,107.26a14.154,14.154,0,0,1-.861,3.778,2.28,2.28,0,0,0,1.913-.192Z",
    transform: "translate(-244.252 -94.205)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M281.764,101.329a.233.233,0,0,0-.031-.424,2.3,2.3,0,0,0-2.107.243.232.232,0,0,0,.282.369h0a1.841,1.841,0,0,1,1.67-.175A.234.234,0,0,0,281.764,101.329Z",
    transform: "translate(-243.809 -91.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M298.012,109.847c.257,3.116,1.028,8.834,2.87,10.135,0,0-.438,3.744-7.034,4.718-7.253,1.071-4-3.089-4-3.089,3.819-1.53,3.283-4.451,2.186-7.108l2.8-3.212C295.89,110.086,297.88,108.252,298.012,109.847Z",
    transform: "translate(-247.759 -95.014)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M303.129,127.817c.591-.534-.6-2.673-1.311-2.971-1.895-.8-9.64-.009-12.552,2.495a3.211,3.211,0,0,0-.229,2.756Z",
    transform: "translate(-247.637 -101.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M354.113,396.71a1.582,1.582,0,0,1-1.222.037.473.473,0,0,1-.158-.529.54.54,0,0,1,.269-.366c.634-.371,2.2.119,2.269.14a.116.116,0,0,1,.024.211A6.205,6.205,0,0,1,354.113,396.71Zm-.861-.714a.65.65,0,0,0-.132.056.313.313,0,0,0-.159.213c-.044.213.038.272.066.292.282.2,1.24-.087,1.9-.42A3.83,3.83,0,0,0,353.251,396Z",
    transform: "translate(-273.961 -213.058)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M355.7,395.261a.116.116,0,0,1-.057,0c-.566-.115-1.819-.854-1.88-1.408a.378.378,0,0,1,.264-.4.635.635,0,0,1,.517,0c.681.278,1.209,1.6,1.23,1.653a.117.117,0,0,1-.019.118A.119.119,0,0,1,355.7,395.261Zm-1.529-1.611a.49.49,0,0,0-.049.019c-.139.062-.131.132-.128.162.036.327.872.92,1.466,1.138-.176-.379-.567-1.121-1-1.3A.411.411,0,0,0,354.17,393.65Z",
    transform: "translate(-274.392 -212.105)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M295.421,407.32c-.63,0-1.238-.086-1.442-.369a.441.441,0,0,1,.01-.507.579.579,0,0,1,.368-.272c.816-.222,2.531.755,2.6.8a.116.116,0,0,1-.035.215A8.565,8.565,0,0,1,295.421,407.32Zm-.778-.951a.868.868,0,0,0-.225.026.351.351,0,0,0-.228.162c-.082.145-.052.216-.023.257.228.317,1.468.324,2.38.2A5.263,5.263,0,0,0,294.643,406.369Z",
    transform: "translate(-249.73 -217.353)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M297.792,406.362a.123.123,0,0,1-.048-.01c-.592-.266-1.765-1.326-1.675-1.882.021-.13.113-.292.433-.324a.846.846,0,0,1,.644.2,3.32,3.32,0,0,1,.762,1.89.117.117,0,0,1-.048.105A.119.119,0,0,1,297.792,406.362Zm-1.2-1.988a.661.661,0,0,0-.069,0c-.209.021-.223.1-.227.13-.054.333.743,1.167,1.347,1.53a2.724,2.724,0,0,0-.647-1.513A.618.618,0,0,0,296.6,404.373Z",
    transform: "translate(-250.62 -216.53)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M304.4,399.761h-4.9L299,388.4h4.9Z",
    transform: "translate(-251.83 -210.045)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M360.373,387.026l-4.52,1.558-4.691-10.709,4.519-1.558Z",
    transform: "translate(-273.322 -205.066)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M352.545,394.124l5.268-1.616a.428.428,0,0,1,.5.2l2.2,3.884a.721.721,0,0,1-.431,1.044c-1.848.533-2.775.7-5.092,1.409-1.426.437-5.022,1.8-7.041,2.207-1.974.4-2.684-1.537-1.893-1.884,3.542-1.556,4.976-3.326,5.814-4.721A1.188,1.188,0,0,1,352.545,394.124Z",
    transform: "translate(-271.088 -211.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M292.467,406.754h5.356a.428.428,0,0,1,.417.335l.969,4.36a.714.714,0,0,1-.706.872c-1.933-.033-4.724-.146-7.153-.146-2.839,0-4.037.155-7.367.155-2.013,0-2.572-2.036-1.729-2.22,3.837-.839,5.715-.93,9.031-2.974A2.271,2.271,0,0,1,292.467,406.754Z",
    transform: "translate(-244.773 -217.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(47.654 24.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M315.54,137.43s11.639,11.035,12.158,16.787c.466,5.162-18.224,10.6-18.224,10.6",
    transform: "translate(-303.799 -131.481)",
    fill: "none",
    stroke: "#ffc3bd",
    strokeWidth: 5.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M307.6,180.074l-4.655,1.4,2.975,4.892s2.738-1.132,3.339-3.455Z",
    transform: "translate(-301.11 -149.052)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M299.822,184.184l1.821,4.036,2.992-.873-2.975-4.892Z",
    transform: "translate(-299.822 -150.033)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(3.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M305.689,131.893c-.443,4.7,9.509,11.979,9.509,11.979l9.579-6.555a20.152,20.152,0,0,0-7.069-7.495C312.228,126.3,306.24,126.048,305.689,131.893Z",
    transform: "translate(-305.675 -127.313)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M305.689,131.893c-.443,4.7,9.509,11.979,9.509,11.979l9.579-6.555a20.152,20.152,0,0,0-7.069-7.495C312.228,126.3,306.24,126.048,305.689,131.893Z",
    transform: "translate(-305.675 -127.313)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(33.926 24.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M277.374,131.476s-4.3,6.6,5.906,41.982l25.953-3.832c-.367-3.589-4.708-19.232-4.85-36.339a6.113,6.113,0,0,0-6.413-6.057c-.758.038-1.534.093-2.3.168a96.52,96.52,0,0,0-11.032,1.63A49.222,49.222,0,0,0,277.374,131.476Z",
    transform: "translate(-276.474 -127.221)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M277.374,131.476s-4.3,6.6,5.906,41.982l25.953-3.832c-.367-3.589-4.708-19.232-4.85-36.339a6.113,6.113,0,0,0-6.413-6.057c-.758.038-1.534.093-2.3.168a96.52,96.52,0,0,0-11.032,1.63A49.222,49.222,0,0,0,277.374,131.476Z",
    transform: "translate(-276.474 -127.221)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M276.918,153.727l.086-.1,6.107.542c.926,3.94-2.471,9.315-4.263,11.806A114.541,114.541,0,0,1,276.918,153.727Z",
    transform: "translate(-242.73 -113.309)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(47.174 171.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M299,388.407l.251,5.855h4.907l-.251-5.855Z",
    transform: "translate(-299.005 -381.301)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M355.685,376.321l-4.521,1.559,2.42,5.519,4.522-1.559Z",
    transform: "translate(-320.496 -376.321)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M293.895,94.637c1.082,4.746,1.956,7.469.3,10.553-2.485,4.639-8.866,4.193-11.345-.134-2.231-3.895-3.625-11,.393-14.2A6.64,6.64,0,0,1,293.895,94.637Z",
    transform: "translate(-244.286 -86.839)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M283.5,98.995l-1.806,1.1.173-6.174a5.309,5.309,0,0,1-3.266-.947c.653-.621,10.811-4.181,13.98-3.561a2.545,2.545,0,0,0,.731-.751s.123.771-.416,1.065a1.736,1.736,0,0,1,1.629.682,2.145,2.145,0,0,0-1.348.078s3.554.533,2.278,5.426a23.422,23.422,0,0,0-.938,8.493s-2.622,2.026-4.908,1.65C287.178,103.382,283.667,100.16,283.5,98.995Z",
    transform: "translate(-243.425 -86.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M277.816,92.1a4.755,4.755,0,0,1-4.63-2.572c2.058-.22,6.345-1.543,9.53-1.764s6.663.367,5.61,1.739S277.816,92.1,277.816,92.1Z",
    transform: "translate(-241.193 -86.152)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M279.676,89.726c-2.337-.326-4.648-2.547-2.885-4.67.653,1.563,5.06,1.381,8.185.727,4.1-.858,6.967.527,5.509,3.331C289.686,90.649,279.676,89.726,279.676,89.726Z",
    transform: "translate(-242.422 -85.056)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M288.905,102.81a5.5,5.5,0,0,1-.157,3.53c-.591,1.477-1.893,1.178-2.571-.1-.61-1.151-1.038-3.306-.039-4.371C287.123,100.819,288.48,101.416,288.905,102.81Z",
    transform: "translate(-246.284 -91.764)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M303.709,201.815s4.211,35.837,7.267,49.879c3.347,15.378,19.851,57.315,19.851,57.315l8.254-2.849S328.5,274.587,325.69,253.088c-2.157-16.514-5.235-53.746-5.235-53.746Z",
    transform: "translate(-253.769 -132.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M346.247,379.648c-.036.012,1.69,3.522,1.69,3.522l9.614-3.121-1.127-2.87Z",
    transform: "translate(-271.296 -205.421)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M307.656,234.823c1.318,9.956,3,21.729,4.491,29.287C314.3,252.543,314.839,237.99,307.656,234.823Z",
    transform: "translate(-255.395 -146.765)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M285.938,203.929s-3.493,33.666-2.959,48.624c.554,15.558,7.823,63.429,7.823,63.429h8.309s-1.529-46.962-1.159-62.241c.4-16.658,6.649-52.567,6.649-52.567Z",
    transform: "translate(-245.205 -132.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M293.6,390.808c-.039,0,.469,3.45.469,3.45h10.107l.273-3.079Z",
    transform: "translate(-249.604 -211.037)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M259.074,145.074s-7.606,11.709-14.549,17.376c-3.594,2.934-15.329-.426-15.329-.426",
    transform: "translate(-223.067 -109.786)",
    fill: "none",
    stroke: "#ffc3bd",
    strokeWidth: 5.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(25.59 28.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M279.241,141.038c1.978,6.465-9.493,13.638-9.493,13.638l-7.454-9.5a41.629,41.629,0,0,1,6.172-8.637C273.537,131.02,277.735,136.116,279.241,141.038Z",
    transform: "translate(-262.295 -134.145)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M279.241,141.038c1.978,6.465-9.493,13.638-9.493,13.638l-7.454-9.5a41.629,41.629,0,0,1,6.172-8.637C273.537,131.02,277.735,136.116,279.241,141.038Z",
    transform: "translate(-262.295 -134.145)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M228.747,170.553l-6.034-1.107.635,5.225a4.347,4.347,0,0,0,5.416-.993Z",
    transform: "translate(-220.396 -119.828)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M218.772,170.624l1.305,3.768,1.647.278-.635-5.225Z",
    transform: "translate(-218.772 -119.828)",
    fill: "#ffc3bd"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroupItem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GroupItem.b804db1a.svg";
export { ForwardRef as ReactComponent };